export enum CategoryType {
  "Campioni in farmacia"
}
